// extracted by mini-css-extract-plugin
module.exports = {"page":"style_page__d2FTu","select":"style_select__1kTbR","form":"style_form__ER59z","loader":"style_loader__281Yv"};